import TablePaginationActions from './TablePaginationActions';

export default TablePaginationActions;
